import React, { useState } from "react";
import { Button, Modal, Table } from "antd";
import config from "appConfig";
import StatisticItem from "./StatisticItem";
import { AD_DUPLICATE_TAB_KEY, AdStatus } from "../../models";
import { buildBaseUrl, formatDate } from "../../services";
import history from "../../history";
import moment from "moment"

export default function UserStatistic({ className, userProfile }) {
  const duration = moment.duration(userProfile.averageChatReplyTimeInSeconds, "seconds")
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const durationFormatted = `${days > 0 ? days + "d" : ""}${hours > 0 ? hours + "h" : ""}${minutes > 0 ? minutes + "min" : ""}${seconds > 0 ? seconds + "sec" : ""}`

  const loginDates = Array.isArray(userProfile.loginDates) ? userProfile.loginDates : [];
  const lastLogin = loginDates.length > 0 ? loginDates[0] : null;
  const [showLoginHistory, setShowLoginHistory] = useState(false);

  const loginHistoryColumns: any = [
    {
      title: "#",
      key: "index",
      width: 60,
      align: "center",
      render: (_: any, __: any, index: number) => index + 1
    },
    {
      title: "Vrijeme prijave",
      dataIndex: "ts",
      key: "ts",
      render: (ts: string) => formatDate(ts, config.fullTimeFormat)
    }
  ];
  const loginHistoryData = loginDates.map((ts: string, idx: number) => ({ key: `${ts}-${idx}`, ts }));

  return (
    <div className={className}>
      <h3>{"Statistika"}</h3>
      {userProfile.isAgency &&
        <p style={{ margin: 0, textAlign: "left" }}>{"XML"}</p>
      }
      <p style={{ margin: 0, textAlign: "left" }}>
        {userProfile.isVerified ? "Korisnik je verificiran" : "Korisnik nije verificiran"}
      </p>
      {lastLogin && (
        <div style={{ marginTop: 8, marginBottom: 24, textAlign: "left" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            <span>Zadnja prijava</span>
            <span>{formatDate(lastLogin, config.fullTimeFormat)}</span>
          </div>
          <Button
            type="default"
            icon="history"
            style={{ marginTop: 12, width: "100%" }}
            onClick={() => setShowLoginHistory(true)}
          >
            Povijest prijava
          </Button>
        </div>
      )}
      <StatisticItem
        link={buildBaseUrl(`/admin/ad?creatorEmail=${encodeURIComponent(userProfile.email)
          }&status=0`)}
        title={"Broj oglasa ukupno"}
        background="#D9EDF7"
        value={userProfile.postedAdsCount}
      />
      <StatisticItem
        link={buildBaseUrl(`/admin/ad?creatorEmail=${encodeURIComponent(userProfile.email)
          }&status=${AdStatus.active}`)}
        title={"Broj aktivnih oglasa"}
        background="#DFF0D8"
        value={userProfile.activeAdsCount}
      />
      <StatisticItem
        link={buildBaseUrl(`/admin/ad?creatorEmail=${encodeURIComponent(userProfile.email)
          }&status=${AdStatus.paused}`)}
        title={"Broj pauziranih oglasa"}
        background="#FCF8E3"
        value={userProfile.pausedAdsCount}
      />
      <StatisticItem
        link={buildBaseUrl(`/admin/ad?creatorEmail=${encodeURIComponent(userProfile.email)
          }&status=${AD_DUPLICATE_TAB_KEY}&isDuplicate=true`)
        }
        title={"Broj duplikata"}
        background="#F2DEDE"
        value={userProfile.duplicateAdsCount}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          Ukupno poslanih poruka
        </span>
        <span>
          {userProfile.sentMessageCount}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          Postotak odgovorenih poruka
        </span>
        <span>
          {userProfile.chatReplyPercentage}%
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          Prosječno za
        </span>
        <span>
          {durationFormatted || "-"}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          Ukupno primljenih poruka
        </span>
        <span>
          {userProfile.chatCount}
        </span>
      </div>
      <Button
        type="default"
        icon="bar-chart"
        style={{ marginTop: 12, width: "100%" }}
        onClick={() => history.push(`/admin/user/statistics/${userProfile.userId}`)}
      >
        Više statistike
      </Button>
      <Modal
        title="Povijest prijava"
        visible={showLoginHistory}
        onCancel={() => setShowLoginHistory(false)}
        footer={null}
        width={480}
      >
        <Table
          dataSource={loginHistoryData}
          columns={loginHistoryColumns}
          pagination={false}
          size="small"
          bordered
          locale={{ emptyText: "Nema zabilježenih prijava" }}
        />
      </Modal>
    </div>
  );
}

UserStatistic.defaultProps = {
  className: ""
};



// WEBPACK FOOTER //
// ./src/containers/UserProfilePage/UserStatistic.tsx